export default {
  backButton: 'All companies',
  showAllContacts: 'Show all contacts',
  contactsInThisCompany: 'Contacts in this company',
  showDetails: 'Show details',
  activities: 'activities',
  contacts: 'contacts',
};
